import React from "react";
import styles from "./style.module.css";
import photo01 from "../../../Assets/brokers/1.png";
import photo02 from "../../../Assets/brokers/2.png";
import photo03 from "../../../Assets/brokers/3.png";
import photo04 from "../../../Assets/brokers/4.png";
import photo05 from "../../../Assets/brokers/5.png";

const Brokers = () => {
  return (
    <div className={styles.container}>
      <div className={styles.brokers}>
        <div className={styles.photo5}>
          <img className={styles.img_res} src={photo05} alt="" />
        </div>
        <div className={styles.photo1}>
          <img className={styles.img_res} src={photo01} alt="" />
        </div>
        <div className={styles.photo2}>
          <img className={styles.img_res} src={photo02} alt="" />
        </div>
        <div className={styles.photo3}>
          <img className={styles.img_res} src={photo03} alt="" />
        </div>
        <div className={styles.photo4}>
          <img className={styles.img_res} src={photo04} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Brokers;
